import { LoginBonusKind } from '../../../../../services/exports/Constants';

export default {
  [LoginBonusKind.MobileAppSignupBonus]: {
    toast: 'Felicitări! Ai câștigat {{amount}} cashback.',
  },
};
